<div  class="main-page-wraper min-h-screen flex flex-col justify-center items-center">

  <!-- style="background: url({{pageBg}});" -->
  <div class="flex flex-wrap justify-evenly min-h-screen  w-full items-center align-middle py-20 gap-6">
    <div class="lg:w-1/3 sm:w-full md:w-full flex lg:justify-end md:justify-center sm:justify-center">

      <!-- <img @slideDownUp [src]="bgUrl" style="width: 50vh!important;" class="logo" /> -->

  
        <!-- <img src="{{logoPath}}" class="logo-main" alt="logo" id="app-logo-sidebar" #appLogo> -->
        <!--<img src="assets/images/temp/LogoSera-black.svg" class="mr-2 logo-main"
        alt="logo">-->
        <div  class="logo" style="width: 50vh!important;">
          <h1 class="font-black text-center text-white" style="font-size: 5rem;">FIX.APP</h1>
        </div>
    
    </div>
    <div
      class="transform easein duration-300 lg:w-1/3 md:w-full sm:w-full flex lg:justify-start md:justify-center sm:justify-center">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

